/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";

const LinkDialogButton = (props) => {
    const setOpen = props.setOpen;
    const openLinkDialog = () => {
        setOpen(true);
    };
    return (
        <Fragment>
            <div onClick={openLinkDialog}>Select Link</div>
        </Fragment>
    );
};
export default LinkDialogButton;
